<div class="container mt-5 mb-5">
    <div class="row justify-content-center">
        <div class="login-form-container">
            <div *ngIf="!heroSectionHidden">
                <h1 *ngIf="!showAsRegistration" class="mb-1">Log In</h1>
                <h1 *ngIf="showAsRegistration" class="mb-4">Create your profile</h1>

                <div *ngIf="this.globalService.whitelabeled">
                    <h5>Powered by <img src="/assets/images/branding/logo-blue.svg" class="powered-by" /></h5>
                </div>

                <div *ngIf="!showAsRegistration" class="mb-4">
                    Don't have a profile?
                    <a [routerLink]="'/sign-up'" class="text-primary text-decoration-underline"> Click here to register </a>
                </div>
                <p *ngIf="showAsRegistration">
                    Once you have your profile on ParkUpp you can start parking or list your parking spot. Already have a profile?
                    <a [routerLink]="'/sign-in'" class="text-primary text-decoration-underline"> Click here to login </a>
                </p>
            </div>

            <div *ngIf="!withPassword && !magicLinkMode" class="d-grid">
                <button type="button" class="btn btn-enterprise-secondary d-block mb-3 rounded" (click)="setSignUpWithPassword(true)"><i class="fa-solid fa-envelope me-2"></i>Login using Email Address</button>
                <button type="button" class="btn btn-primary btn-google mb-3 rounded" (click)="signUpWithGoogle()">Login With Google</button>
                <button type="button" class="btn btn-primary btn-facebook d-block mb-3 rounded" (click)="signUpWithFacebook()">Login With Facebook</button>
                <button *ngIf="!showAsRegistration" type="button" class="btn btn-enterprise-secondary d-block mb-3 rounded" (click)="setMagicLinkMode(true)"><i class="fa-solid fa-wand-magic-sparkles me-2"></i>Login with Magic Link</button>
            </div>
            <div *ngIf="magicLinkMode">
                <button type="button" class="btn btn-enterprise-secondary mb-3 rounded" (click)="setMagicLinkMode(false)">Back to social login</button>
                <div *ngIf="!magicLinkSent">
                    <p class="mb-3">Enter your email address and we'll send you a sign-in link. No password required.</p>
                    <form [formGroup]="magicLinkForm" (ngSubmit)="sendMagicLink()">
                        <div class="form-group mb-3">
                            <label>Email</label>
                            <input type="email" name="magicLinkEmail" id="magicLinkEmail" formControlName="email" placeholder="Email" class="form-control" />
                            <div invalidMessage="email" class="invalid-feedback">{{ magicLinkForm.get('email') | validationErrors }}</div>
                        </div>
                        <button type="submit" [disabled]="loading" class="btn btn-enterprise-secondary">
                            <i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i>
                            <span *ngIf="!loading">Send Magic Link</span>
                        </button>
                    </form>
                </div>
                <div *ngIf="magicLinkSent" class="alert alert-success">
                    <i class="fa-solid fa-circle-check me-2"></i>
                    If that email is registered with ParkUpp, we've sent you a sign-in link. Check your inbox (and your spam folder, just in case).
                </div>
            </div>
            <div *ngIf="withPassword">
                <button type="button" class="btn btn-enterprise-secondary mb-3 rounded" (click)="setSignUpWithPassword(false)">Back to social login</button>
                <form [formGroup]="formGroup" (ngSubmit)="signUpWithPassword()">
                    <div class="form-group mb-3">
                        <label>Email</label>
                        <input type="email" name="email" id="email" formControlName="email" placeholder="Email" class="form-control" />
                        <div invalidMessage="email" class="invalid-feedback">{{ formGroup.get('email') | validationErrors }}</div>
                    </div>
                    <div class="form-group mb-3">
                        <label>Password</label>
                        <input type="password" name="password" id="password" formControlName="password" placeholder="Password" class="form-control" />
                        <small class="text-muted">Minimum 6 characters</small>
                        <br />
                        <div invalidMessage="password" class="invalid-feedback">{{ formGroup.get('password') | validationErrors }}</div>
                        <a (click)="forgotPassword()" class="text-enterprise-secondary text-decoration-underline"><small>Click here to reset your password</small></a>
                    </div>
                    <button type="submit" [disabled]="loading" class="btn btn-enterprise-secondary"><i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i><span *ngIf="!loading">Continue</span></button>
                </form>
            </div>
            <div *ngIf="error" class="alert alert-warning">
                {{ error }}
            </div>
            <div *ngIf="!valid && formGroup.invalid" class="alert alert-info">Please complete required fields</div>
        </div>
        <p class="terms-text">
            <small>
                I agree to ParkUpp's
                <a target="_blank" [routerLink]="['/terms-and-conditions']" class="text-body text-decoration-underline">Terms</a> and
                <a target="_blank" [routerLink]="['/privacy']" class="text-body text-decoration-underline">Privacy Policy</a>
                and to receive email. Protected by reCAPTCHA
                (<a href="https://policies.google.com/privacy" target="_blank" rel="noopener" class="text-body text-decoration-underline">Privacy</a>
                and
                <a href="https://policies.google.com/terms" target="_blank" rel="noopener" class="text-body text-decoration-underline">Terms</a>).
            </small>
        </p>
    </div>
</div>
